module.exports = __webpack_public_path__ + "img/laravel-white.ba0b1fce.png";